"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitize = exports.Sanitizer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _xss = _interopRequireDefault(require("xss"));
var _excluded = ["Component", "safelySetInnerHTML", "approvedAttributes"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var defaultApprovedAttributes = {
  sup: ['class'],
  span: ['style', 'class']
};
var makeXssOptions = function makeXssOptions(approvedAttributes) {
  var isApprovedAttribute = function isApprovedAttribute(tag, name) {
    return !approvedAttributes[tag] || approvedAttributes[tag] && approvedAttributes[tag].includes(name);
  };
  return {
    onIgnoreTagAttr: function onIgnoreTagAttr(tag, name, value) {
      return isApprovedAttribute(tag, name) ? "".concat(name, "=\"").concat(_xss["default"].escapeAttrValue(value), "\"") : '';
    }
  };
};
var sanitize = exports.sanitize = function sanitize(dangerousHTML) {
  var approvedAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultApprovedAttributes;
  var options = makeXssOptions(approvedAttributes);
  return (0, _xss["default"])(dangerousHTML, options);
};
var Sanitizer = exports.Sanitizer = function Sanitizer(_ref) {
  var Component = _ref.Component,
    safelySetInnerHTML = _ref.safelySetInnerHTML,
    approvedAttributes = _ref.approvedAttributes,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var sanitizedHTML = {
    __html: sanitize(safelySetInnerHTML, approvedAttributes)
  };

  // eslint-disable-next-line react/no-danger
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    "data-rendered": "sanitize",
    dangerouslySetInnerHTML: sanitizedHTML
  }, otherProps));
};
Sanitizer.propTypes = {
  safelySetInnerHTML: _propTypes["default"].string.isRequired,
  approvedAttributes: _propTypes["default"].objectOf(_propTypes["default"].arrayOf(_propTypes["default"].string)),
  Component: _propTypes["default"].node
};
Sanitizer.defaultProps = {
  Component: 'span',
  approvedAttributes: defaultApprovedAttributes
};